<template>
    <v-container  class="d-flex align-center justify-center" style="max-width: 1400px;">
      <v-layout justify-left wrap class="white lighten-4 caption">
  
        <v-dialog v-model="popup" max-width="400px" hide-overlay>
          <v-toolbar color="light-green lighten-2" height="100">
            <v-toolbar-title class="body-2 elevation-0">Duplicate - You have already submitted the details.</v-toolbar-title>
          </v-toolbar>
          <v-card>
            <v-card-actions class="justify-center">
              <v-btn variant="text" @click="goHome()">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <v-col cols="12" md="10" sm="10" lg="10">
          <v-card class="elevation-0">
              <v-card class="body-1 pa-0 elevation-0" style="max-width: 100%" >
              <v-img
                :src="require('@/assets/gopi.jpg')"
              />
            </v-card>
          </v-card>
        <!---------------------------------------------Stepper Starts--->
        
        <v-stepper v-model="e6" vertical><br>
            <strong class="h1 text"> Its a special event with limited seats, first come first serve basis. </strong> <br>
          <v-stepper-step :complete="e6 > 1" step="1" editable>Validate Membership
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card
              color="white lighten-1"
              class="elevation-0 mb-12"
              max-height="50px"
            >
            <v-responsive max-width="450">
                <v-text-field
                  name="primaryemail"
                  v-on:keyup="handleInputOnKeyup"
                  :rules="emailRules"
                  label="Primary Member E-mail"
                  outlined
                  dense
                  width = "300"
                  id="primaryemail"
                  v-model="Json.primaryemail"
                  type="primaryemail"
                  placeholder=" "
                  required
                ></v-text-field>
              </v-responsive>
          </v-card>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                @submit.prevent="onSignIn"
                action="/dashboards/analytical"
              >
                <v-btn
                  color="light-blue"
                  dark
                  class="caption text-right"
                  submit
                  @click="checkMembership()"
                  ><v-icon left>mdi-account-circle</v-icon>Validate</v-btn>
            </v-form>
          </v-stepper-content>
      
          <v-stepper-step :complete="e6 > 2" step="2" editable>
            Reserve Count
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-card
              color="white lighten-1"
              class="mb-12 elevation-0"
              max-height="700px"
            >
              <div v-if="this.Json.message ==='No membership data found for the email provided or Payment not done'">
                  <v-layout wrap>
                        <v-alert dense text colored-border color="red">
                          Membership not found for this primary email. You can still reserve your family as non members.
                        </v-alert>
                        <v-flex xs12 md4>
                          <v-text-field
                            v-if="validatedNonMember"
                            label="Email"
                            dense
                            outlined
                            :rules="emailRules"
                            v-model="Json.nonMemberEmail"
                            class="body-2 mr-1 purple-input"
                          />
                        </v-flex>
                        <v-flex xs12 md3>
                          <v-text-field
                            v-if="validatedNonMember"
                            label="First Name"
                            dense
                            outlined
                            :rules="nameRules"
                            v-model="Json.firstname"
                            class="body-2 mr-1 purple-input"
                          />
                        </v-flex>
                        <v-flex xs12 md3>
                          <v-text-field
                            v-if="validatedNonMember"
                            label="Last Name"
                            dense
                            outlined
                            :rules="nameRules"
                            v-model="Json.lastname"
                            class="body-2 mr-1 purple-input"
                          />
                        </v-flex>
                        <v-flex xs12 md4>
                          <v-select
                            v-if="validatedNonMember"
                            label="Head Count Including Kids"
                            class="body-2 mr-1 purple-input"
                            dense
                            outlined
                            v-model="countJson.adultsCount"
                            color="primary"
                            :items="[0, 1, 2, 3 , 4 , 5, 6]"
                          />
                        </v-flex>
                  </v-layout>
              </div>
  
              <v-container py-0>
                <v-layout wrap>
                  <v-alert
                        v-if="validatedMember"
                        dense
                        text
                        type="green"
                      >
                      You are a proud member of Charlotte Tamil Sangam.
                    </v-alert><br>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-if="validatedMember"
                      label="First Name"
                      dense
                      v-model="Json.firstname"
                      class="body-2 mr-1 purple-input"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-if="validatedMember"
                      label="Last Name"
                      dense
                      v-model="Json.lastname"
                      class="body-2 mr-1 purple-input"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-if="validatedMember"
                      label="Year"
                      dense
                      v-model="Json.year"
                      class="body-2 mr-1 purple-input"
                      disabled
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-if="validatedMember"
                      label="Membership"
                      class="body-2 mr-1 purple-input"
                      dense
                      v-model="Json.membershipcategory"
                      disabled
                      color="primary"
                    />
                  </v-flex>
                  
                  <v-flex xs12 md6>
                    <v-select
                      v-if="validatedMember"
                      label="Head Count Including Kids"
                      class="body-2 mr-1 purple-input"
                      dense
                      outlined
                      v-model="countJson.adultsCount"
                      color="primary"
                      :items="[0, 1, 2, 3 , 4 , 5, 6]"
                    />
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card>
            <v-btn color="primary" @click="e6 = 3">Continue</v-btn>
          </v-stepper-content>
  
          <v-stepper-step :complete="e6 > 3" step="3" editable>Payment Details</v-stepper-step>
          <v-stepper-content step="3">
            <v-card
              color="white lighten-1"
              max-height="350px"
              class="elevation-0"
            >
            <v-flex xs12 md1>
                    <v-text-field
                    v-if="this.Json.message !=='No membership data found for the email provided or Payment not done'"
                      class="caption"
                      variant="plain"
                      dense
                      outlined
                      prefix="$"
                      v-model="memberAmount"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md1>
                    <v-text-field
                    v-if="this.Json.message ==='No membership data found for the email provided or Payment not done'"
                      class="caption"
                      dense
                      outlined
                      variant="plain"
                      prefix="$"
                      v-model="nonMemberAmount"
                      readonly
                    ></v-text-field>
                  </v-flex> 
                  Note : On selecting Proceed To Payment button, you will be redirected to Cltts Payment page.
            On that screen update the above displayed amount and complete your payment. You will receive a confirmation email
            </v-card><br>
                  <v-flex xs12 md3>
                    <v-btn
                    v-if="this.Json.message !=='No membership data found for the email provided or Payment not done'"
                      class="caption"
                      color="green"
                      outlined
                      submit
                      @click="submitCount()"
                      >Submit & Proceed To Pay</v-btn
                    >
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-btn
                      v-if="this.Json.message ==='No membership data found for the email provided or Payment not done'"
                      color="primary"
                      outlined
                      class="caption"
                      submit
                      @click="nonMemberSubmitCount()"
                      >Submit & Proceed To Pay</v-btn
                    >
                  </v-flex>
          </v-stepper-content>
          
      </v-stepper>
  <!---------------------------------------------Stepper Ends--->
        </v-col>
  
        <v-col cols="12" md="2" sm="2" lg="2">
          <v-expansion-panels
            v-model="panel"
            :disabled="disabled"
            multiple
            focusable
          >
            <v-expansion-panel>
              <v-expansion-panel-header class="caption" style="background:lightskyblue;color:black">For CLTTS Members</v-expansion-panel-header>
              <v-expansion-panel-content>
                75 $ per head irrespective of age.<br /> Members would be given first priority
              </v-expansion-panel-content>
              <v-expansion-panel-header class="caption" style="background:lightskyblue;color:black">For Non-Members</v-expansion-panel-header>
              <v-expansion-panel-content>
                75 $ per head irrespective of age.<br />
              </v-expansion-panel-content>
              <v-expansion-panel-header class="caption" style="background:lightskyblue;color:black">For Membership</v-expansion-panel-header>
              <v-expansion-panel-content>
                To take membership for 2024 use the following link to complete payment
                <a href="https://www.charlottetamilsangam.org/#/PaymentGateway">Payments</a><br />
              </v-expansion-panel-content>
              <v-expansion-panel-header class="caption" style="background:lightskyblue;color:black">Tech Issues</v-expansion-panel-header>
              <v-expansion-panel-content >
                If u are member and still dont see your data using primary email
                id or any technical issues reach out to
                <a
                  href="mailto: cltsangam@gmail.com?subject=CLTTS-Membership Issue"
                  > Narasimman</a>
                <br />
              </v-expansion-panel-content>
              
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
  
      </v-layout>
    </v-container>
  </template>
  
  <script>
  import ReportServices from "@/services/ReportServices"
  
  export default {
    name: "FullLogin",
    data() {
      return {
        e6: 1,
        panel: [0, 0],
        readonly: false,
        popup: false,
        nameRules: [(v) => !!v || "This Field is required"],
        emailRules: [
          (v) => !!v || "Primary E-mail is required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
          (v)=> !!v || 'Email is required'
        ],
        form: false,
        valid: true,
        text: "",
        Json: {
          primaryemail: "",
        },
        countJson: {
          adultsCount: 0,
          VBCount: 0,
          CBCount: 0,
          GBCount: 0,
          primaryemail: "",
          firstname: "",
          lastname: "",
          membershipcategory: "",
          paymentstatus: "",
          year: "",
          nonMemberEmail: "",
          memberAmount: 0,
          nonMemberAmount: 0,
        },
        primaryemail: "",
        show3: false,
      };
    },
    computed: {
      formIsValid() {
        return this.primaryemail !== "";
      },
      validatedMember () {
        return (
          this.Json.membershipcategory === "Family" ||
          this.Json.membershipcategory === "Paarivallal" ||
          this.Json.membershipcategory === "Single"
        )
      },
      validatedNonMember () {
        return (
          this.Json.membershipcategory !== "Family" ||
          this.Json.membershipcategory !== "Paarivallal" ||
          this.Json.membershipcategory !== "Single"
        )
      },
      nonMemberAmount() {
        var totalRows = 0;
        totalRows =
          this.countJson.adultsCount * 75 
        return totalRows;
      },
      memberAmount() {
        var tRows = 0;
        tRows =
        this.countJson.adultsCount * 75 
        return tRows;
      },
    },
    methods: {
      handleInputOnKeyup() {
        this.Json.primaryemail = this.Json.primaryemail.toLowerCase().trim();
      },
      goHome() {
        this.$router.push({ path: "/ReserveMe", replace: true });
        this.popup = false
        this.e6 = 1
      },
      nonMember() {
        this.$router.push({ path: "/NonMemberPayments", replace: true });
      },
      async checkMembership() {
        this.primaryemail = this.Json.primaryemail;
        this.refresh();
        this.e6 = 2
      },
      async nonMemberSubmitCount() {
        this.countJson.primaryemail = this.Json.nonMemberEmail;
        this.countJson.firstname = this.Json.firstname;
        this.countJson.lastname = this.Json.lastname;
        this.countJson.membershipcategory = "NonMember";
        this.countJson.year = "2024";
        this.countJson.checkinstatus = "Y";
        this.countJson.event = "MeetAndGreet-2024";
        this.countJson.amount = this.nonMemberAmount;
        this.responseData = await ReportServices.reserveCountForSpecialEvent(
          this.countJson
        )
        this.validate()
      },
      async submitCount() {
        this.countJson.primaryemail = this.Json.primaryemail;
        this.countJson.firstname = this.Json.firstname;
        this.countJson.lastname = this.Json.lastname;
        this.countJson.membershipcategory = this.Json.membershipcategory;
        this.countJson.year = this.Json.year;
        this.countJson.paymentstatus = this.Json.paymentstatus;
        this.countJson.checkinstatus = "Y";
        this.countJson.event = "MeetAndGreet-2024";
        this.countJson.memberid = this.Json._id;
        this.countJson.amount = this.memberAmount;
        this.responseData = await ReportServices.reserveCountForSpecialEvent(
          this.countJson
        )
        this.validate()
      },
      validate() {
        if (this.responseData.data === "Already Submitted") {
          this.popup = true;
        } else {
          this.$router.push({ path: "/NonMemberPayments", replace: true })
        }
      }, 
      async refresh() {
        this.profileData = await ReportServices.validateMembership(this.primaryemail)
        this.Json = this.profileData.data;
        this.Json.nonMemberEmail = this.primaryemail
      },
    },
    async mounted() {
      this.refresh()
    }
  };
  </script>